import classnames from "classnames";
import React, { ReactNode, useState } from "react";

import { getTranslatedFacetName } from "@utils/search/facetTranslation.utils";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import "./facet.scss";

export const TRANSLATED_FACET_TK_PREFIX = "facet.translatedFacet.label.";

type SearchRefinementListComponentProps = {
    facetName: string;
    children?: ReactNode;
};

const FacetComponent = ({
    facetName,
    children,
}: SearchRefinementListComponentProps) => {
    const [collapsed, setCollapsed] = useState(false);

    const { t } = useGranite();
    const translatedFacetName = getTranslatedFacetName(facetName, t);

    const handleOnLabelClick = () => setCollapsed(isCollapsed => !isCollapsed);

    return (
        <div className={classnames("facet", collapsed && "facet--collapsed")}>
            <h3
                className="d-flex justify-content-between cursor-pointer align-items-center my-0"
                onClick={handleOnLabelClick}
            >
                {translatedFacetName}
                <i className="las la-angle-down ml-1"></i>
            </h3>
            <div className={"facet__items position-relative"}>
                <div>{children}</div>
            </div>
        </div>
    );
};

export { FacetComponent };
